import React, { useContext } from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import { CustomAlertContextProvider } from "utils/context/CustomAlertContext"
import { ModalContextProvider } from "utils/context/ModalContext"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !localStorage.getItem("authUser")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }

      return (
        <Layout>
          <CustomAlertContextProvider>
            <ModalContextProvider>
              <Component {...props} />
            </ModalContextProvider>
          </CustomAlertContextProvider>
        </Layout>
      )
    }}
  />
)

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware
